<template>
  <div>
    <!-- <div class="h1">
      <div class="barss">
        <div class="w">
          <img class="logo" src="../../assets/img/pagess/sky102/logo.png" alt="">
          <div class="right">更精確！更好用！更实战！</div>
        </div>
        <div class="w2">
          <div class="lis1">
            <img src="../../assets/img/pagess/sky102/0.2.png" alt="">
          </div>
          <div class="lis2">
            <img src="../../assets/img/pagess/sky102/0.3.png" alt="">
          </div>
          <div class="lis3">
            <img src="../../assets/img/pagess/sky102/0.4.png" alt="">
            <img src="../../assets/img/pagess/sky102/0.5.png" alt="">
          </div>
          <img class="btn1" @click="to_xaizai()" src="../../assets/img/pagess/sky102/btn1.gif" alt="">
        </div>

      </div>

    </div> -->
    <div class="h1s"> <img class="btn1" @click="to_xaizai()" src="../../assets/img/pagess/sky102/btn1.gif" alt=""></div>

    <div class="h2">
      <img src="../../assets/img/pagess/sky102/2.jpg" alt="">
    </div>
    <div class="h3" ref="obtain">
      <img src="../../assets/img/pagess/sky102/3.jpg" alt="">
    </div>
    <div class="h4">
      <img src="../../assets/img/pagess/sky102/4.jpg" alt="">
    </div>
    <div class="h5">
      <img src="../../assets/img/pagess/sky102/5.1.jpg" alt="">
    </div>
    <div class="h6">
      <img src="../../assets/img/pagess/sky102/6.jpg" alt="">
    </div>
    <div class="h7">
      <img src="../../assets/img/pagess/sky102/7.jpg" alt="">
    </div>
    <div class="h8">
      <img src="../../assets/img/pagess/sky102/8-1.png" alt="">
    </div>
    <div class="bottomsss">
      <div class="boxx"></div>
      <p>————&nbsp;投资有风险入市需谨慎&nbsp;————</p>
      <p>从事证券投资或期货交易，请通过合法证券期货经营机构进行&nbsp;&nbsp;&nbsp; 合法机构名单可到中国证监会网站 (<a
          href="http://www.csrc.gov.cn/">www.csrc.gov.cn</a>)查询
      </p>
      <p>北京天相财富管理顾问有限公司河北分公司 &nbsp;&nbsp;&nbsp; <a
          href="https://beian.miit.gov.cn/">冀ICP备2021023389号-1</a>&nbsp;&nbsp;&nbsp;
        执证编号：91110102MA001GJE1N</p>
      <p>天相股多多软件版本号：v1.3.1.1288 更新时间：2022年2月</p>
      <p style=" 
    text-decoration: underline;cursor:pointer;" class="qwer">
        <!-- 联系电话:010-********&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; -->
        <span @click="open_yinsi()" style="margin-right:10px">隐私保护政策</span>
        <span @click="open_fuwuxieyi()">软件服务协议</span>
      </p>
      <p>开发者名称:北京天相财富管理顾问有限公司</p>
    </div>
    <div class="box"></div>
    <div class="bar" v-if="res">
      <div class="w">
        <img @click="to_xaizai()" class="btn2" src="../../assets/img/pagess/sky102/btn2.gif" alt="">
      </div>
    </div>

  </div>
</template>


<script>
export default {
  data() {
    return {
      res: false,
    };
  },
  mounted() {
    this.clientIp();
    // 滚动条的获取
    window.addEventListener("scroll", this.handleScrollx, true);
  },
  methods: {
    to_xaizai() {
      window.open("https://cdn.juniubang.com/apk/GDD1002.exe");
      this.post_leilei_data();
      // this.clientIp();
    },

    post_leilei_data() {
      this.$http
        .post("/to_exe", {
          url: window.location.href,
          qhclickid: this.$route.query.bd_vid,
          code: this.$route.query.code,
          type: "baidu1",
        })
        .then((res) => {
           
        });
    },

    handleScrollx() {
      if (this.$refs.obtain.getBoundingClientRect().top < 890) {
        this.res = true;
      } else {
        this.res = false;
      }
        
    },
    clientIp() {
      this.$http
        .post("/client_ip", { url: window.location.href })
        .then((res) => {
          window.localStorage.setItem("_number", res.data);
        });
    },
    open_yinsi() {
      window.open("https://ins.juniubang.com/images/隐私政策4.7.pdf");
    },
    open_fuwuxieyi() {
      window.open("https://ins.juniubang.com/images/应用权限4.7.pdf");
    },
  },
};
</script>

<style lang="less" scoped>
.h1s {
  width: 100%;
  height: 901px;
  background: url(../../assets/img/pagess/sky102/1.png) no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  .btn1 {
    width: 542px;
    height: 123px;
  }
}
img {
  display: block;
}
.bottomsss {
  width: 100%;
  height: 150px;
  background-color: #021754;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  .boxx {
    width: 100%;
    height: 30px;
  }
  .qwer span:hover {
    color: #fff;
  }
  a {
    font-size: 12px;
    color: #fff;
  }
  p {
    margin: 0;
    font-size: 12px;
    color: #6e7a9e;
  }
}
.box {
  width: 100%;
  height: 200px;
  background-color: #021754;
}
.h1 {
  width: 100%;
  height: 901px;
  background: url(../../assets/img/pagess/sky102/0.6.png) no-repeat;

  background-size: 100% 100%;
  // display: flex;
  // flex-direction: column;
  // align-items: center;
  // justify-content: flex-end;
  .barss {
    width: 100%;
    height: 54px;
    background-color: #000088;
    .w {
      width: 1200px;
      margin: 0 auto;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .logo {
        width: 231px;
        height: 38px;
      }
      .right {
        color: #fff;
        font-size: 16px;
      }
    }
    .w2 {
      width: 1200px;
      margin: 0 auto;
      height: 847px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .lis3 {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-evenly;
      }
    }
  }
  .btn1 {
    width: 542px;
    height: 123px;
  }
}
.bar {
  width: 100%;
  height: 150px;
  background: url(../../assets/img/pagess/sky102/bar.png) no-repeat;
  background-size: 100% 100%;
  .w {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
    .btn2 {
      width: 353px;
      height: 107px;
    }
  }
}
* {
  -moz-user-select: none; /* Firefox私有属性 */
  -webkit-user-select: none; /* WebKit内核私有属性 */
  -ms-user-select: none; /* IE私有属性(IE10及以后) */
  -khtml-user-select: none; /* KHTML内核私有属性 */
  -o-user-select: none; /* Opera私有属性 */
  user-select: none; /* CSS3属性 */
}
img {
  width: 100%;
}
.bar {
  position: fixed;
  bottom: 0;
}
</style>


// WEBPACK FOOTER //
// src/pages/pagess/gdd104.vue